import styled from 'styled-components';

export const FileUploadInput = styled.input`
  display: none;
`;
